import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=1fde92db&scoped=true&"
import script from "./invoice.vue?vue&type=script&lang=js&"
export * from "./invoice.vue?vue&type=script&lang=js&"
import style0 from "./invoice.vue?vue&type=style&index=0&id=1fde92db&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde92db",
  null
  
)

export default component.exports